import { Component } from '@angular/core';
import { UtilsService } from '../../../services/utils.service';
import { Router } from '@angular/router';
import { OrganizationsService } from '../../../services/organizations.service';

@Component({
  selector: 'app-new-organization',
  templateUrl: './new-organization.component.html',
  styleUrls: ['./new-organization.component.scss']
})
export class NewOrganizationComponent {

  organization = {
    name: ''
  };

  constructor(private graphqlService: OrganizationsService,
              private utilsService: UtilsService,
              private router: Router) {
  }


  createOrganization() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.organization.name);
    if (requiredSuccess) {
      this.graphqlService.create(this.organization).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Organization Created !!', '');
          this.router.navigate(['/organizations']);
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to create organization.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/organizations/new-organization/new-organization.component.ts